import React, { forwardRef, memo } from 'react';

import { DEFAULT_IFRAME_TITLE } from '../protocol/embedProtocol';

const EmbedIframe = forwardRef((props, ref) => (
    <iframe
        ref={ref}
        allow={props.allow}
        className={props.className}
        onError={props.onError}
        onLoad={props.onLoad}
        sandbox={props.sandbox}
        src={props.src}
        style={props.style}
        title={props.title === undefined ? DEFAULT_IFRAME_TITLE : props.title}
    />
));

EmbedIframe.displayName = 'EmbedIframe';

export default memo(EmbedIframe);
